import { ICON_PATHS } from '@/components/Icon';
import { pushCmsEventTracking } from '@/lib/gtm/pushCmsEventTracking';
import type { EventTrackingResolved } from '@/lib/gtm/pushCmsEventTracking';

export const resolveIcon = (value: string | null): string | null =>
  value ? (ICON_PATHS[value] ?? value) : null;

// Pushes whatever Event Tracking entries are configured on the tapped item —
// top-level or nested, global or local menu, identically — plus the menu's
// own tracking (configured once on the Menu content type), so every item
// click also carries whatever tracking is defined at the menu level.
export const trackMenuClick = (
  label: string,
  ...trackingLists: (EventTrackingResolved[] | undefined)[]
): void => {
  const tracking = trackingLists.flatMap((list) => list ?? []);
  pushCmsEventTracking(tracking, { label });
};

export const resolveHref = (href: string | null): string => {
  if (!href) {
    return '#';
  }
  if (!href.startsWith('http')) {
    return href;
  }
  try {
    const url = new URL(href);
    if (
      typeof window !== 'undefined' &&
      url.hostname === window.location.hostname
    ) {
      return url.pathname + url.search + url.hash;
    }
  } catch {
    // malformed URL — fall through to return as-is
  }
  return href;
};

export const externalProps = (href: string | null) =>
  href?.startsWith('http')
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};
